import EventBus from "./event-bus";
import {errorHandler} from "./utils";

const axios = require('axios');


export function getNotices() {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'merchant/notices', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function setNoticeAsRead(id) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'merchant/notice/read?id=' + id, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response['data'];
      EventBus.$emit("showLoading", false);
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/notices.js